module.exports = __webpack_public_path__ + "static/media/block.7afb2e1f.svg";